import config from './config';
//#endregion
//#region Functions
// user-api
// 1.0
// http://test5-bg-api-gateway.zhiketong.net[80]/user-api/swagger-ui.html
/**
 * 根据权限id获取对应用户
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getAdminGetAdminByRights(query, header) {
    var url = "/user-api/admin/getAdminByRights";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据adminid查询Right
 * @param header The http request header parameters.
 */
export function getAdminGetAdminList(header) {
    var url = "/user-api/admin/getAdminList";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 根据酒店id获取对应的商务mm
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getAdminGetMmByHotel(query, header) {
    var url = "/user-api/admin/getMmByHotel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据adminid查询Right
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getAdminGetRightByAdminid(query, header) {
    var url = "/user-api/admin/getRightByAdminid";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 清洗数据
 * @param header The http request header parameters.
 */
export function getEbRemindCleanData(header) {
    var url = "/user-api/eb/remind/cleanData";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 获取所有系统通知列表(eb)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbRemindGetAllRemindByType(body, header) {
    var url = "/user-api/eb/remind/get_all_remind_by_type";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据员工获取系统通知弹窗(eb)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbRemindGetRemindByUser(query, header) {
    var url = "/user-api/eb/remind/get_remind_by_user";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量获取系统通知列表(eb端)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbRemindGetRemindListByTypes(body, header) {
    var url = "/user-api/eb/remind/get_remind_list_by_types";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 奖励查询-会员访问记录
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbRewardGetMemberRewardRecord(body, header) {
    var url = "/user-api/eb/reward/get_member_reward_record";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 奖励查询-页面功能描述信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbRewardSetUrlPageInfo(body, header) {
    var url = "/user-api/eb/reward/set_url_page_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 学员导师关联
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserBindMentorStudentRelation(body, header) {
    var url = "/user-api/eb/user/bind_mentor_student_relation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 清洗日历房分销待确认订单通知数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserCleanRoom(query, header) {
    var url = "/user-api/eb/user/clean_room";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 清洗vpos场景值数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserCleanVposScene(query, header) {
    var url = "/user-api/eb/user/clean_vpos_scene";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询当前user
 * @param header The http request header parameters.
 */
export function getEbUserGetCurrentUser(header) {
    var url = "/user-api/eb/user/getCurrentUser";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 集团推广权限
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetBrandShareRights(query, header) {
    var url = "/user-api/eb/user/get_brand_share_rights";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据openId和AppId获取User
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetCIdByOpenIdAndAppId(query, header) {
    var url = "/user-api/eb/user/get_cId_by_openId_and_AppId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店员工收藏的产品ID列表(商户版)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetCollectProductList(query, header) {
    var url = "/user-api/eb/user/get_collect_product_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取EB操作日志
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserGetEbOperateLog(body, header) {
    var url = "/user-api/eb/user/get_eb_operate_log";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据员工编号获取所有绑定酒店信息(不包含代理)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetHotelsInfoByUserId(query, header) {
    var url = "/user-api/eb/user/get_hotels_info_by_userId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询导师详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetMentorDetail(query, header) {
    var url = "/user-api/eb/user/get_mentor_detail";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId查询导师详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetMentorDetailByUserId(query, header) {
    var url = "/user-api/eb/user/get_mentor_detail_by_userId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 推荐学员
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserGetRecommendStudent(body, header) {
    var url = "/user-api/eb/user/get_recommend_student";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 学员列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserGetStudentList(body, header) {
    var url = "/user-api/eb/user/get_student_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取用户授权信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetUserAuthInfo(query, header) {
    var url = "/user-api/eb/user/get_user_auth_info";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId获取当前员工酒店公众号二维码
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetUserHotelQrcodeByUserId(query, header) {
    var url = "/user-api/eb/user/get_user_hotel_qrcode_by_userId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取员工是否展示报表入口权限
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserGetUserReportRight(query, header) {
    var url = "/user-api/eb/user/get_user_report_right";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通知配置删除
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserNotificationDelete(body, header) {
    var url = "/user-api/eb/user/notification_delete";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通知配置查询
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserNotificationGet(body, header) {
    var url = "/user-api/eb/user/notification_get";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通知配置查询已配置用户
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserNotificationGetUserids(query, header) {
    var url = "/user-api/eb/user/notification_get_userids";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 通知配置列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserNotificationList(body, header) {
    var url = "/user-api/eb/user/notification_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 通知配置保存
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserNotificationSave(body, header) {
    var url = "/user-api/eb/user/notification_save";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取酒店员工收藏的产品ID列表，含过滤(商户版)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserSearchCollectProductList(body, header) {
    var url = "/user-api/eb/user/search_collect_product_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置导师查看过规则
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserSetReadRules(query, header) {
    var url = "/user-api/eb/user/set_read_rules";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 提交用户授权信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserSubmitUserAuthInfo(body, header) {
    var url = "/user-api/eb/user/submit_user_auth_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取新手展示的状态
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserUserGuideStatus(query, header) {
    var url = "/user-api/eb/user/user_guide_status";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 新手展示已使用
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getEbUserUserGuideViewed(query, header) {
    var url = "/user-api/eb/user/user_guide_viewed";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 酒店员工收藏产品/取消收藏(商户版)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbUserUserHotelCollect(body, header) {
    var url = "/user-api/eb/user/user_hotel_collect";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取图形验证码
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbValidGetImgCaptcha(body, header) {
    var url = "/user-api/eb/valid/get_img_captcha";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取短信验证码
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbValidGetSmsCaptcha(body, header) {
    var url = "/user-api/eb/valid/get_sms_captcha";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取短信验证码（含图形验证码校验）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbValidGetSmsCaptchaWithImg(body, header) {
    var url = "/user-api/eb/valid/get_sms_captcha_with_img";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 校验短信验证码
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postEbValidVerifySmsCaptcha(body, header) {
    var url = "/user-api/eb/valid/verify_sms_captcha";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据姓名和身份证校验有效性
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postIdCardCertificationByIdName(body, header) {
    var url = "/user-api/idCard/certification_by_id_name";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取身份证认证协议
 * @param header The http request header parameters.
 */
export function getIdCardGetIdcardAuthAgreement(header) {
    var url = "/user-api/idCard/get_idcard_auth_agreement";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 数据表迁移
 * @param header The http request header parameters.
 */
export function getJobConvert(header) {
    var url = "/user-api/job/convert";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 数据表变更数据迁移
 * @param header The http request header parameters.
 */
export function getJobConvertV2(header) {
    var url = "/user-api/job/convert_v2";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 部门首单提醒 08:00~22:00执行，每30min执行一次
 * @param header The http request header parameters.
 */
export function getJobDepartmentFirstOrder(header) {
    var url = "/user-api/job/department_first_order";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 首单提醒测试
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getJobFirstOrder(query, header) {
    var url = "/user-api/job/first_order";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 酒店首单提醒 08:00~22:00执行,每5min执行一次
 * @param header The http request header parameters.
 */
export function getJobHotelFirstOrder(header) {
    var url = "/user-api/job/hotel_first_order";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 员工部门为空数据清洗
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postJobInitDepartmentIdIsEmptyData(body, header) {
    var url = "/user-api/job/init_department_id_is_empty_data";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 初始化系统通知历史数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getJobInitRemindSystemHistory(query, header) {
    var url = "/user-api/job/init_remind_system_history";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 给酒店员工发送协议公司销售额报表，每天早上8点执行
 * @param header The http request header parameters.
 */
export function getJobSendGmvReport(header) {
    var url = "/user-api/job/send_gmv_report";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 给酒店员工发送协议公司销售额报表，每天早上8点执行
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getJobSingleSendGmvReport(query, header) {
    var url = "/user-api/job/single_send_gmv_report";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 同步通知配置
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getJobSyncNotificationConfig(query, header) {
    var url = "/user-api/job/sync_notification_config";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 更新未填写拼音的字段,每5分钟更新
 * @param header The http request header parameters.
 */
export function getJobUpdateUserPinyin(header) {
    var url = "/user-api/job/update_user_pinyin";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 添加/删除外籍员工
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserAddOrDelUserForeign(body, header) {
    var url = "/user-api/mis/user/add_or_del_user_foreign";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 添加员工导师
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserAddUserMentor(body, header) {
    var url = "/user-api/mis/user/add_user_mentor";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取外籍员工列表信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getMisUserGetUserForeignEmployeeList(query, header) {
    var url = "/user-api/mis/user/get_user_foreign_employee_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取商户员工信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserGetUserHotelInfoList(body, header) {
    var url = "/user-api/mis/user/get_user_hotel_info_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取员工导师列表信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserGetUserMentorInfoList(body, header) {
    var url = "/user-api/mis/user/get_user_mentor_info_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取员工导师操作日志列表信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserGetUserMentorOperateLogList(body, header) {
    var url = "/user-api/mis/user/get_user_mentor_operate_log_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取员工学员列表信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserGetUserStudentInfoList(body, header) {
    var url = "/user-api/mis/user/get_user_student_info_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 修改导师状态
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postMisUserUpdateUserMentorStatus(body, header) {
    var url = "/user-api/mis/user/update_user_mentor_status";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据类型筛选当前时间酒店的通知用户
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postNotifyGetCurrentAvailableUserList(body, header) {
    var url = "/user-api/notify/get_current_available_user_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据类型查询当前时间酒店的通知用户
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 * @deprecated
 */
export function getNotifyGetCurrentAvailableUsers(query, header) {
    var url = "/user-api/notify/get_current_available_users";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * EB端订单通知用户可通知类型筛选，每家酒店可通知的用户列表中，过滤出可以通知给用户的通知类型
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postNotifyGetEbAvailableUserNotifyType(body, header) {
    var url = "/user-api/notify/get_eb_available_user_notify_type";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * EB端订单通知用户可通知类型筛选(旧)，每家酒店可通知的用户列表中，过滤出可以通知给用户的通知类型
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postNotifyGetEbAvailableUserNotifyTypeOld(body, header) {
    var url = "/user-api/notify/get_eb_available_user_notify_type_old";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 添加EB操作日志
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOperatelogAddEbOperateLog(body, header) {
    var url = "/user-api/operatelog/add_eb_operate_log";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 添加MIS操作日志
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOperatelogAddMisOperateLog(body, header) {
    var url = "/user-api/operatelog/add_mis_operate_log";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取EB初始化以及操作日志
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOperatelogGetEbInitAndOperateLog(body, header) {
    var url = "/user-api/operatelog/get_eb_initAndOperate_log";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取EB操作日志
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postOperatelogGetEbOperateLog(body, header) {
    var url = "/user-api/operatelog/get_eb_operate_log";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取最后一个操作人的id
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getOperatelogGetLastOperatorId(query, header) {
    var url = "/user-api/operatelog/get_last_operator_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询酒店是否需要在商户版展示弹窗
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getRemindCheckNeedShowByHotelId(query, header) {
    var url = "/user-api/remind/check_need_show_by_hotel_id";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 增加系统消息提醒(增加消息后状态为待发布)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindDoAddSystemRemid(body, header) {
    var url = "/user-api/remind/doAddSystemRemid";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除系统消息提醒
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindDoDelSystemRemid(body, header) {
    var url = "/user-api/remind/doDelSystemRemid";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 启用功能
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindDoOpenFunction(body, header) {
    var url = "/user-api/remind/doOpenFunction";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 撤销系统消息提醒
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindDoRevocationSystemRemid(body, header) {
    var url = "/user-api/remind/doRevocationSystemRemid";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 设置消息为已读或已弹窗(eb)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindDoSetRemindSystem(body, header) {
    var url = "/user-api/remind/doSetRemindSystem";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 修改系统消息提醒
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindDoUpdataSystemRemid(body, header) {
    var url = "/user-api/remind/doUpdataSystemRemid";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取区域和商户类型
 * @param header The http request header parameters.
 */
export function postRemindGetAreaAndShanghuType(header) {
    var url = "/user-api/remind/getAreaAndShanghuType";
    return config.request({ url: url, method: 'post', header: header, });
}
/**
 * 查询系统通知列表(eb)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindGetRemindSystemListByEb(body, header) {
    var url = "/user-api/remind/getRemindSystemListByEb";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询系统通知列表MIS
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindGetRemindSystemLists(body, header) {
    var url = "/user-api/remind/getRemindSystemLists";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询系统消息提醒详情
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindGetSystemRemind(body, header) {
    var url = "/user-api/remind/getSystemRemind";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取用户系统通知数(eb)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindGetUserRemindSystemCount(body, header) {
    var url = "/user-api/remind/getUserRemindSystemCount";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据员工获取系统通知弹窗
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getRemindGetRemindByUser(query, header) {
    var url = "/user-api/remind/get_remind_by_user";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取系统通知列表(c端)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindGetRemindListByC(body, header) {
    var url = "/user-api/remind/get_remind_list_by_c";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取通知列表(商户版和官微通)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postRemindGetRemindListByShanghu(body, header) {
    var url = "/user-api/remind/get_remind_list_by_shanghu";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 同步代理数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSyncIwideAgent(query, header) {
    var url = "/user-api/sync_iwide/agent";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 同步多个代理数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSyncIwideMultiAgent(query, header) {
    var url = "/user-api/sync_iwide/multi_agent";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 同步多个员工数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSyncIwideMultiStaff(query, header) {
    var url = "/user-api/sync_iwide/multi_staff";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 同步员工数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSyncIwideStaff(query, header) {
    var url = "/user-api/sync_iwide/staff";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId统计商户各项数据
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getSyncIwideStatistics(query, header) {
    var url = "/user-api/sync_iwide/statistics";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 校验新老员工绑定信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserBusinessCheckUserRelation(body, header) {
    var url = "/user-api/user/business/check_user_relation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 删除所有学员绑定关系
 * @param header The http request header parameters.
 */
export function getUserBusinessDeleteAllBindRelation(header) {
    var url = "/user-api/user/business/delete_all_bind_relation";
    return config.request({ url: url, method: 'get', header: header, });
}
/**
 * 删除保护期推荐人记录
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function postUserBusinessDeleteUserRecommendProtection(query, header) {
    var url = "/user-api/user/business/delete_user_recommend_protection";
    return config.request({ url: url, method: 'post', query: query, header: header, });
}
/**
 * 获取绑定的学员列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserBusinessGetBindNewUsers(query, header) {
    var url = "/user-api/user/business/get_bind_new_users";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店员工是否卖过单
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserBusinessGetHotelUserSellOrder(query, header) {
    var url = "/user-api/user/business/get_hotel_user_sell_order";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询师生关系和师生详情
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserBusinessGetMentorRelationAndDetail(query, header) {
    var url = "/user-api/user/business/get_mentor_relation_and_detail";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取推荐的学员列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserBusinessGetRecommendNewUsers(query, header) {
    var url = "/user-api/user/business/get_recommend_new_users";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取卖货人保护期推荐人
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserBusinessGetScanCodeReferees(query, header) {
    var url = "/user-api/user/business/get_scan_code_referees";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取保护期推荐人
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserBusinessGetUserRecommendProtection(query, header) {
    var url = "/user-api/user/business/get_user_recommend_protection";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取会员推荐人酒店
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserBusinessGetUserRecommendProtectionHotel(body, header) {
    var url = "/user-api/user/business/get_user_recommend_protection_hotel";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 忽略指定推荐的学员
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserBusinessIgnoreRecommendNewUser(body, header) {
    var url = "/user-api/user/business/ignore_recommend_new_user";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 更新导师学员卖货信息（结算使用）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserBusinessRecordMentorStudentsOrderInfo(body, header) {
    var url = "/user-api/user/business/record_mentor_students_order_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 记录员工首单（结算使用）
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserBusinessRecordUserFirstOrder(body, header) {
    var url = "/user-api/user/business/record_user_first_order";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存卖货人保护期推荐人
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserBusinessSaveScanCodeReferees(body, header) {
    var url = "/user-api/user/business/save_scan_code_referees";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 保存新老员工关系
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserBusinessSaveUserRelation(body, header) {
    var url = "/user-api/user/business/save_user_relation";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 检查身份证认证信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserCheckIdcardAuthInfo(body, header) {
    var url = "/user-api/user/check_idcard_auth_info";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据酒店id员工id批量查询团建比例
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserDeptGroupBonusRateList(body, header) {
    var url = "/user-api/user/dept_group_bonus_rate_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据hotelId和userId查询userHotel
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserDoCheckHotelUser(query, header) {
    var url = "/user-api/user/doCheckHotelUser";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId和userId查询userHotel,包括集团员工
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserDoCheckHotelUserIncludeBrand(query, header) {
    var url = "/user-api/user/doCheckHotelUserIncludeBrand";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 预下载列表
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserDownloadList(body, header) {
    var url = "/user-api/user/download/list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * downloadUserInfosByUserIds
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserDownloadUserInfoByUserIds(body, header) {
    var url = "/user-api/user/download_user_info_by_userIds";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据hotelId,部门id，用户名模糊查找员工
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserFindUserByDeptAndName(query, header) {
    var url = "/user-api/user/find_user_by_dept_and_name";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId,用户名模糊查找员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserFindUserByName(query, header) {
    var url = "/user-api/user/find_user_by_name";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据admin字段查询Admin
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetAdminByAdmin(body, header) {
    var url = "/user-api/user/getAdminByAdmin";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据adminId查询Admin
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetAdminByAdminId(query, header) {
    var url = "/user-api/user/getAdminByAdminId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId查询userHotel,商户版APP
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetAppUserHotelByUserId(query, header) {
    var url = "/user-api/user/getAppUserHotelByUserId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据user_id查询end_wechat_account表信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetEndWechatAccountByUserid(query, header) {
    var url = "/user-api/user/getEndWechatAccountByUserid";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId查询集团商户和部门信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetHotelAndDeptInfoByUserId(body, header) {
    var url = "/user-api/user/getHotelAndDeptInfoByUserId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据hotelId和userId获取员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetHotelUserByUserIdAndType(query, header) {
    var url = "/user-api/user/getHotelUserByUserIdAndType";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId获取所有员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetHotelUsersByHotelId(query, header) {
    var url = "/user-api/user/getHotelUsersByHotelId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId和hotelIdList查询是否存在酒店员工
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetHotelUsersByUserIdAndHotelIdList(query, header) {
    var url = "/user-api/user/getHotelUsersByUserIdAndHotelIdList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId和userIds获取一组员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetHotelUsersByUserIds(query, header) {
    var url = "/user-api/user/getHotelUsersByUserIds";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId和userIds获取一组员工信息(包括联盟)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetHotelUsersByUserIdsWithUnion(query, header) {
    var url = "/user-api/user/getHotelUsersByUserIdsWithUnion";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId和userIds获取一组员工信息(包括联盟)
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetHotelUsersByUserIdsWithUnionPost(body, header) {
    var url = "/user-api/user/getHotelUsersByUserIdsWithUnionPost";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据userids获取认证状态
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetIdCardStatus(query, header) {
    var url = "/user-api/user/getIdCardStatus";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据图片地址识别背面的身份证信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetIssueFromImage(query, header) {
    var url = "/user-api/user/getIssueFromImage";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据图片地址识别名字和身份证号码
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetNameAndIdFromImage(query, header) {
    var url = "/user-api/user/getNameAndIdFromImage";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userids批量获取用户名
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetNameWithUserIds(query, header) {
    var url = "/user-api/user/getNameWithUserIds";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店员工ID获取其酒店的销售关系和共享酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetRelatedHotelInfoByUserId(query, header) {
    var url = "/user-api/user/getRelatedHotelInfoByUserId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店员工ID获取其酒店的共享酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetShareHotelListByUserId(query, header) {
    var url = "/user-api/user/getShareHotelListByUserId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId查询userHotel的关键信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetSimpleHotelUserByUserId(query, header) {
    var url = "/user-api/user/getSimpleHotelUserByUserId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据user和hotelId查询用户和部门信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserAndDepartmentByUserIds(query, header) {
    var url = "/user-api/user/getUserAndDepartmentByUserIds";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店id和权限查询user
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserByHotelCodeAndRights(query, header) {
    var url = "/user-api/user/getUserByHotelCodeAndRights";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId查询user
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserByUserId(query, header) {
    var url = "/user-api/user/getUserByUserId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId和userId查询UserHotel
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserHotelByHotelIdAndUserId(query, header) {
    var url = "/user-api/user/getUserHotelByHotelIdAndUserId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId查询userHotel
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserHotelByUserId(query, header) {
    var url = "/user-api/user/getUserHotelByUserId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 商户版根据userId查询员工酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserHotelByUserIdToShangHu(query, header) {
    var url = "/user-api/user/getUserHotelByUserIdToShangHu";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 查询工关联的酒店列表（员工代理关系酒店，管理集团关系酒店、及其共享酒店）
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserRelatedHotelIds(query, header) {
    var url = "/user-api/user/getUserRelatedHotelIds";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据deptId获取员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUsersByHotelDept(query, header) {
    var url = "/user-api/user/getUsersByHotelDept";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId和departmentId查询一级代理信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetAgentInfoByHotelIdDepartmentId(query, header) {
    var url = "/user-api/user/get_agent_info_by_hotelId_departmentId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId和brandId获取协议公司
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetBrandCorpList(query, header) {
    var url = "/user-api/user/get_brand_corp_list";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店所在集团的所有酒店的员工,必须有手机号或者名字
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetBrandUserHotel(query, header) {
    var url = "/user-api/user/get_brand_user_hotel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId查询默认酒店信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetDefaultHoelinfoByUserId(query, header) {
    var url = "/user-api/user/get_default_hoelinfo_by_userId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据hotelId获取所有部门和员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetDeptUser(query, header) {
    var url = "/user-api/user/get_dept_user";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 批量获取传播角色
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetFirstShareRole(body, header) {
    var url = "/user-api/user/get_first_share_role";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取酒店协议公司报表接收用户列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetGmvReportToUsers(query, header) {
    var url = "/user-api/user/get_gmv_report_to_users";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取酒店报表接收用户列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetHotelReportToUsers(query, header) {
    var url = "/user-api/user/get_hotel_report_to_users";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据员工编号获取所有绑定酒店信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetHotelsByUserId(query, header) {
    var url = "/user-api/user/get_hotels_by_userId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取人脸识别结果
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetIdcardAuthFaceidResult(body, header) {
    var url = "/user-api/user/get_idcard_auth_faceid_result";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取人脸识别入口url
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetIdcardAuthFaceidUrl(body, header) {
    var url = "/user-api/user/get_idcard_auth_faceid_url";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 获取通知用户列表
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetNotificationUsers(query, header) {
    var url = "/user-api/user/get_notification_users";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId查询相同身份证的user信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetSameIdcardUsersByUserId(query, header) {
    var url = "/user-api/user/get_same_idcard_users_by_userId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取某个酒店的团建账户
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetSecondBonusOwner(query, header) {
    var url = "/user-api/user/get_second_bonus_owner";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * getShanghuOpenIdByUserIds
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetShanghuOpenidByUserIdList(body, header) {
    var url = "/user-api/user/get_shanghu_openid_by_userId_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据hotelIds获取预售券，权益卡，组合商品数量
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetTicketCount(query, header) {
    var url = "/user-api/user/get_ticket_count";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 获取接收产品消息类型员工
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetTicketMsgType(query, header) {
    var url = "/user-api/user/get_ticket_msg_type";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据手机号获取员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserByMobile(query, header) {
    var url = "/user-api/user/get_user_by_mobile";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据userId查询user(仅钱袋子用)
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserInfoByUserId(query, header) {
    var url = "/user-api/user/get_user_info_by_userId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * getUserInfosByUserIds
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserGetUserInfoListByUserIdList(body, header) {
    var url = "/user-api/user/get_user_info_list_by_userId_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据member获取员工是否是共享酒店员工
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserShareByMemberId(query, header) {
    var url = "/user-api/user/get_user_share_by_memberId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店id以及用户名模糊查询员工基本信息列表，分页查询
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUserinfoByHotelAndName(query, header) {
    var url = "/user-api/user/get_userinfo_by_hotel_and_name";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据手机号获取员工信息集合
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUsersByHotel(query, header) {
    var url = "/user-api/user/get_users_by_hotel";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据酒店id以及用户名查询员工信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUsersByHotelAndName(query, header) {
    var url = "/user-api/user/get_users_by_hotel_and_name";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据身份证查询所有user信息
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetUsersWithSameIdcard(query, header) {
    var url = "/user-api/user/get_users_with_same_idcard";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据金房卡用户ID和inter_id查询直客通身份
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserGetZktUserForIwide(query, header) {
    var url = "/user-api/user/get_zkt_user_for_iwide";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 共享酒店获取
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserQueryShareHotelSimpleInfoByToHotelIdList(query, header) {
    var url = "/user-api/user/queryShareHotelSimpleInfoByToHotelIdList";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 识别名字和身份证号码并保存
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserSaveNameAndIdFromImage(body, header) {
    var url = "/user-api/user/saveNameAndIdFromImage";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据userId、hotelId修改员工默认酒店
 * @param query The http request query parameters.
 * @param header The http request header parameters.
 */
export function getUserSetDefaultHoelByUserId(query, header) {
    var url = "/user-api/user/set_default_hoel_by_userId";
    return config.request({ url: url, method: 'get', query: query, header: header, });
}
/**
 * 根据员工ID修改员工认证状态及身份证信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserUpdateStatusAndInfoByUserId(body, header) {
    var url = "/user-api/user/update_status_and_info_by_user_id";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 已认证员工更新身份证照片
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserUpdateUserIdImage(body, header) {
    var url = "/user-api/user/update_user_id_image";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据userId批量查询部门信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserUserDeptList(body, header) {
    var url = "/user-api/user/user_dept_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据userId批量查询名字
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserUserNameList(body, header) {
    var url = "/user-api/user/user_name_list";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 根据user_id查询end_wechat_account表信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserWechatAccount(body, header) {
    var url = "/user-api/user/wechat_account";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询用户所在部门id
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserCardGetUserDepartmentId(body, header) {
    var url = "/user-api/userCard/getUserDepartmentId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 查询员工信息
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserCardGetUserInfoByUserId(body, header) {
    var url = "/user-api/userCard/getUserInfoByUserId";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
/**
 * 给新用户发送消息推广商户版
 * @param body The http request body parameters.
 * @param header The http request header parameters.
 */
export function postUserPromoteSendNewUserMessage(body, header) {
    var url = "/user-api/user_promote/send_new_user_message";
    return config.request({ url: url, method: 'post', body: body, header: header, });
}
//#endregion
